import { GetterTree } from 'vuex';
import { State } from './state';

import { RootState } from '@/modules/ewerp/store';
import { Printdata } from '@/modules/ewerp/models/PrintdataModels';

export type Getters = {
  printdata(state: State): Array<Printdata>;
};

export const getters: GetterTree<State, RootState> & Getters = {
  printdata(state) {
    return state.printdata;
  },
};
